var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags has-addons"},[_c('span',{staticClass:"tag is-dark is-medium"},[_vm._v(_vm._s(_vm.auto.pg))]),_c('a',{staticClass:"tag is-delete is-medium",on:{"click":function($event){return _vm.selectAuto()}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8789d56c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sca_Componentes/acceso/AutosRecepcion.vue
// module id = 1928
// module chunks = 0